module.exports = __webpack_public_path__ + "static/media/Seal.aab77ce7.svg";